import { AsyncPipe } from '@angular/common';
import { Component, forwardRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { AbstractFilterDropdownComponent } from 'shared/components/atoms';
import { FreightTypesFilterViewModel } from 'shared/components/molecules/filters/freight-types-filter-dropdown/freight-types-filter.view-model';
import { SiteFreightTypes } from 'shared/types';
import { FilterDropdownComponent } from '../filter-dropdown/filter-dropdown.component';

@Component({
  selector: 'app-freight-types-filter-dropdown',
  templateUrl: './freight-types-filter-dropdown.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FreightTypesFilterDropdownComponent),
      multi: true,
    },
    FreightTypesFilterViewModel,
  ],
  imports: [FilterDropdownComponent, AsyncPipe, ReactiveFormsModule],
})
export class FreightTypesFilterDropdownComponent extends AbstractFilterDropdownComponent<SiteFreightTypes['id']> {
  private vm = inject(FreightTypesFilterViewModel);
  public options$ = this.vm.freightTypesData$;

  constructor() {
    super();
    this.formControl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((freightTypeIds: SiteFreightTypes['id']) => {
        this.onChange(freightTypeIds);
      });
  }
}
